import React from 'react';

/**
 * Componente de mensagem de sucesso exibida após a conclusão do agendamento
 * 
 * @param {Object} props - Propriedades do componente
 * @param {Function} props.onNewBooking - Função chamada ao clicar para fazer um novo agendamento
 * @param {Object} props.salonConfig - Configurações do salão
 * @param {string} props.salonConfig.primaryColor - Cor primária do tema
 */
const SuccessMessage = ({ 
  onNewBooking,
  salonConfig = {}
}) => {
  const { primaryColor = '#4F46E5' } = salonConfig;
  
  return (
    <div className="bg-white rounded-lg shadow-sm p-6 text-center animate-fade-in">
      <div className="flex justify-center mb-6">
        <div 
          className="w-16 h-16 rounded-full flex items-center justify-center"
          style={{ backgroundColor: primaryColor }}
        >
          <svg 
            xmlns="http://www.w3.org/2000/svg" 
            className="h-10 w-10 text-white" 
            fill="none" 
            viewBox="0 0 24 24" 
            stroke="currentColor"
          >
            <path 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              strokeWidth={2} 
              d="M5 13l4 4L19 7" 
            />
          </svg>
        </div>
      </div>
      
      <h2 className="text-2xl font-bold mb-3">Agendamento Solicitado!</h2>
      
      <p className="text-gray-600 mb-6">
        Seu agendamento foi recebido com sucesso e será analisado pela nossa equipe.
        Você receberá uma confirmação via WhatsApp em breve.
      </p>
      
      <button
        type="button"
        onClick={onNewBooking}
        className="w-full sm:w-auto px-6 py-3 rounded-lg text-white font-medium hover:opacity-90 transition-opacity"
        style={{ backgroundColor: primaryColor }}
      >
        Fazer Novo Agendamento
      </button>
    </div>
  );
};

export default SuccessMessage; 